"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var GetDecimalPlaces_1 = require("Utils/GetDecimalPlaces");
var FormatCurrency_1 = require("Utils/FormatCurrency");
var REASONABLE_MAX_DECIMAL_PLACES = 6;
var FixedCostRateDisplayComponent = (function (_super) {
    __extends(FixedCostRateDisplayComponent, _super);
    function FixedCostRateDisplayComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calculateDecimalPlaces = function () {
            var _a = _this.props, rateAmount = _a.rateAmount, forceShowDecimalPlaces = _a.forceShowDecimalPlaces, idealDecimalPlaces = _a.idealDecimalPlaces;
            var decimalPlaces = Math.min((0, GetDecimalPlaces_1.getDecimalPlaces)(rateAmount), REASONABLE_MAX_DECIMAL_PLACES);
            if (decimalPlaces > 0 || forceShowDecimalPlaces) {
                decimalPlaces = Math.max(decimalPlaces, idealDecimalPlaces);
            }
            return decimalPlaces;
        };
        return _this;
    }
    FixedCostRateDisplayComponent.prototype.render = function () {
        var _a = this.props, currencyCode = _a.currencyCode, rateAmount = _a.rateAmount;
        return (react_1.default.createElement("div", { className: "item-component" }, (0, FormatCurrency_1.formatCurrency)(rateAmount, currencyCode, this.calculateDecimalPlaces())));
    };
    FixedCostRateDisplayComponent = __decorate([
        mobx_react_1.observer
    ], FixedCostRateDisplayComponent);
    return FixedCostRateDisplayComponent;
}(react_1.default.Component));
exports.default = FixedCostRateDisplayComponent;
